(function () {
  'use strict';
  function init(root) {
    if (root.dataset.msReady) return;
    root.dataset.msReady = '1';

    /* Filters / sort submit on change */
    var form = root.querySelector('[data-ms-filters]');
    if (form) {
      form.querySelectorAll('[data-ms-auto]').forEach(function (el) {
        el.addEventListener('change', function () {
          // drop empty price inputs so the URL stays clean
          form.querySelectorAll('input[type="number"]').forEach(function (n) { if (n.value === '') n.disabled = true; });
          form.submit();
        });
      });
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (n) { if (n.value === '') n.disabled = true; });
      });
    }

    /* Only one dropdown open at a time; close on outside click */
    var dds = root.querySelectorAll('[data-ms-dd]');
    dds.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        dds.forEach(function (o) { if (o !== d) o.open = false; });
        var panel = d.querySelector('.ms-dd__panel');
        var sum = d.querySelector('summary');
        if (panel && sum) {
          var r = sum.getBoundingClientRect();
          var left = Math.min(r.left, window.innerWidth - panel.offsetWidth - 12);
          panel.style.left = Math.max(12, left) + 'px';
          panel.style.position = 'fixed';
          panel.style.top = (r.bottom) + 'px';
        }
      });
    });
    document.addEventListener('click', function (e) { dds.forEach(function (d) { if (!d.contains(e.target)) d.open = false; }); });
    window.addEventListener('scroll', function () { dds.forEach(function (d) { d.open = false; }); }, { passive: true });

    /* Load more without page reload */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ms-more]');
      if (!btn) return;
      e.preventDefault();
      btn.classList.add('is-busy');
      btn.textContent = 'Lädt …';
      fetch(btn.dataset.href, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (htmlText) {
          var doc = new DOMParser().parseFromString(htmlText, 'text/html');
          var grid = root.querySelector('[data-ms-grid]');
          var nextGrid = doc.querySelector('[data-ms-grid]');
          if (grid && nextGrid) Array.prototype.slice.call(nextGrid.children).forEach(function (c) { grid.appendChild(c); });
          var more = root.querySelector('.ms-more');
          var nextMore = doc.querySelector('.ms-more');
          if (more) { if (nextMore) more.replaceWith(nextMore); else more.remove(); }
        })
        .catch(function () { window.location.href = btn.dataset.href; });
    });
  }
  function boot() { document.querySelectorAll('[data-ms]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
